import { useMutation, useQueryClient } from '@tanstack/react-query';
import dataService from 'services/dataService';

import { showResult } from '../utils';
import { getUnregisteredConversationNotesKey } from './useUnregisteredConversationNotes';

interface Props {
  onSuccess: () => void;
}

const deleteUnregisteredConversationNotesFn = async ({
  conversationId,
  noteGuid,
}: {
  conversationId: number;
  noteGuid: string;
}) => {
  const API_UNREGISTERED_CONVERSATION_NOTES = `core-2/conversations/${conversationId}/notes`;
  const { data, error } = await dataService.deleteObject(
    API_UNREGISTERED_CONVERSATION_NOTES,
    {
      noteGuid,
    },
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

export const useDeleteUnregisteredConversationNotes = ({
  onSuccess,
}: Props) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading, ...other } = useMutation({
    mutationFn: deleteUnregisteredConversationNotesFn,
    onSuccess(data, variables) {
      const unregisteredConversationNotesKey =
        getUnregisteredConversationNotesKey(variables.conversationId);
      onSuccess();
      queryClient.invalidateQueries({
        queryKey: unregisteredConversationNotesKey,
      });
    },
  });

  return {
    deleteUnregisteredConversationNote: mutate,
    deleteUnregisteredConversationNoteLoading: isLoading,
    ...other,
  };
};
